import { render, staticRenderFns } from "./TopPagesWidget.vue?vue&type=template&id=d57e6712&"
import script from "./TopPagesWidget.vue?vue&type=script&lang=js&"
export * from "./TopPagesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports